import { Constants } from "src/billinglatest/constants";

/**
 * Resolve an ISO 3166-1 alpha-2 country code to its full display name (e.g.
 * `"TH"` → `"Thailand"`). Shared by the Payment & Shipping form step and the
 * Checkout review card so both render the same label from a single source.
 *
 * Wizard state and the API payload keep the raw ISO code; this is display-only.
 * Unknown/unmapped codes fall back to the raw code rather than blank.
 */
export const countryName = (code: string): string =>
  Constants.Countries[code as keyof typeof Constants.Countries] ?? code;
